import { render, staticRenderFns } from "./LiquidacionReportesTable.vue?vue&type=template&id=3124b097&"
import script from "./LiquidacionReportesTable.vue?vue&type=script&lang=js&"
export * from "./LiquidacionReportesTable.vue?vue&type=script&lang=js&"
import style0 from "./LiquidacionReportesTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports